import { WithStyles, withStyles, Button, Grid } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { userStyles } from "../styles";
import FiltersContainer from "./FiltersContainer";
import ListingContainer from "./ListingContainer";
import TopNav from "../components/TopNav";

interface ContentRequestProps extends WithStyles<typeof userStyles> {
  
}
interface ContentRequestState {
  noDataPanel: boolean;
}

class ContentRequestContainer extends Component<
  ContentRequestProps,
  ContentRequestState
> {
  constructor(props: ContentRequestProps) {
    super(props);
    this.state = {
      noDataPanel: false,
    };
  }

  render() {
    const { classes } = this.props;
    const { noDataPanel } = this.state;
   
    return (
      <div>
        <Grid container>
        <TopNav />
        </Grid>
        <Grid container>
          <Grid item xs={3}>
            <FiltersContainer />
          </Grid>

          <Grid item xs={9}>
            <ListingContainer />
          </Grid>
        </Grid>      
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(ContentRequestContainer));
